import React, { ReactElement, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getAvailableLanguages } from 'b2b-apps/shop/i18n/utils/language';
import { EnhancedComponentProps, EnhancedComponentType, WrappedComponentType } from './';

export const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const { pathname } = useLocation();
    const isHomePage = useMemo(
      (): boolean => [...getAvailableLanguages(), ''].some(lang => pathname.replaceAll('/', '') === lang),
      [pathname],
    );

    return <Component {...props} isHomePage={isHomePage} />;
  };

  return WithContainer;
};
